import Vue from "vue";
import DatePicker from "./DatePicker.vue";
import DateInput from "./DateInput.vue";

Vue.component("date-picker", DatePicker);
Vue.component("date-input", DateInput);
